const locale = {
	// #region Fields
	DIALOG_COMMON_ID: 'ID',
	DIALOG_COMMON_TITLE: 'Nome',
	DIALOG_COMMON_DESCRIPTION: 'Descrizione',
	DIALOG_COMMON_ORDER: 'Ordine',
	DIALOG_COMMON_TITLE_INITIALS: 'Iniziali',
	DIALOG_COMMON_DISABLED: 'Disabilitato',
	DIALOG_COMMON_ERP_ID: 'ID ERP'
	// #endregion
};

export default locale;
